module.exports = require("chalk");


//////////////////
// WEBPACK FOOTER
// external "chalk"
// module id = 38
// module chunks = 0